import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import firebase from 'firebase/app';
import 'firebase/auth';

import reducers from './reducers';
import Dashboard from './views/dashboard';
import Placeholder from './views/dashboard/Placeholder';
import ExternalLogin from './views/external-login';

const config = {
    apiKey: "AIzaSyBMbWsKSkpiFpppFc_ckWuy4jCMA9fQBZQ",
    authDomain: "pos-ios.firebaseapp.com",
    databaseURL: "https://pos-ios.firebaseio.com",
    projectId: "pos-ios",
    storageBucket: "pos-ios.appspot.com",
    messagingSenderId: "148217872920"
};
firebase.initializeApp(config);

const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);
const store = createStoreWithMiddleware(reducers);

const ExternalRoute = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={props => {
            const updateProps = { ...props };
            const xprops = window.xprops;
            return <Component {...updateProps} {...xprops} />;
        }} />
    );
};

class Routers extends Component {
    render() {
        return (
            <Provider store={store}>
                <BrowserRouter>
                    <Switch>
                        {/* <Route exact path="/login" cookies={cookies}
                            render={(props) => {
                                const activeUser = cookies.get('activeUser');
                                if (activeUser && activeUser.access_token) {
                                    return <Redirect to="/" />
                                }
                                return <Login {...props} />;
                            }}
                        /> */}
                        {/* <Route exact path="/error" component={ErrorPage} /> */}
                        {/* <Route path="/" component={Dashboard} /> */}
                        <ExternalRoute exact path="/external-login" component={ExternalLogin} />
                        <Route path="/" component={Placeholder} />


                        {/* <AdminRoute exact path="/apps" component={MainMenu} cookies={cookies} />
                        <AdminRoute exact path="/apps/:appId" component={EditApps} cookies={cookies} />

                        <AdminRoute exact path="/news" component={MainMenu} cookies={cookies} />
                        <AdminRoute exact path="/news/:newsId" component={EditNews} cookies={cookies} />

                        <AdminRoute exact path="/faqs" component={MainMenu} cookies={cookies} />
                        <AdminRoute exact path="/faqs/:faqId" component={EditFAQ} cookies={cookies} />

                        <AdminRoute exact path="/" component={MainMenu} cookies={cookies} /> */}
                    </Switch>
                </BrowserRouter>
            </Provider>
        );
    }
}

export default Routers;



// WEBPACK FOOTER //
// ./src/Routers.js